// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "activity-" + (chunkId === 184 ? "dashboard-lazy" : chunkId) + ".js?v=" + {"184":"7d396852dfc700636084","783":"b396830dcddd72b0ef85"}[chunkId] + "";
};